import {
  CommandBar,
  Dropdown,
  Spinner,
  SpinnerSize,
} from 'office-ui-fabric-react';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { SORTING_KEYS } from '../../../constants/sortingKeys';
import { getAllHearingsInitialize } from '../../../features/actions/api';
import { isFetchingHearingsSelector } from '../../../features/apiFeatures/hearingSlice';
import {
  allHearingTypesSelector,
  isFetchingHearingTypesSelector,
} from '../../../features/apiFeatures/hearingTypeSlice';
import {
  deleteFieldTemplate,
  fieldTemplateBeingUpdatedSelector,
  loadFieldTemplateAdminPage,
  setFieldTemplateModel,
  setIsPanelOpen,
} from '../../../features/pageFeatures/fieldTemplateAdministrationPageSlice';
import {
  filterAndSortingKeys,
  noSelectionKey,
} from '../../../utilities/filterAndSortingsUtil';
import { optionsMapperWithNoSelection } from '../../../utilities/mapperFunctions';
import { FieldTemplateLists } from './fieldTemplateAdministrationPage/FieldTemplateLists';
import { getFieldTemplateCommandBarItems } from './fieldTemplateAdministrationPage/getFieldTemplateCommandBarItems';
import { HeaderWithCommandBar } from './HeaderWithCommandBar';

const FieldTemplateAdministrationPage = () => {
  const dispatch = useDispatch();
  const { t: translator } = useTranslation();

  useEffect(() => {
    dispatch(loadFieldTemplateAdminPage());
    return function cleanup() {
      dispatch(getAllHearingsInitialize());
    };
  }, [dispatch]);

  const [titleFilter, setTitleFilter] = useState(null);
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [selectedFieldTemplateKey, setSelectedFieldTemplateKey] = useState(
    noSelectionKey,
  );
  const [filterAndSortingSelection, setFilterAndSortingSelection] = useState({
    [filterAndSortingKeys.sortingKey]: SORTING_KEYS.TITLEALPHABETICAL,
    [filterAndSortingKeys.title]: noSelectionKey,
  });
  const [selectedHearingTypeKey, setSelectedHearingTypeKey] = useState(
    noSelectionKey,
  );

  const hearingTypes = useSelector(allHearingTypesSelector);
  const isFetchingHearingTypes = useSelector(isFetchingHearingTypesSelector);
  const isFetchingHearings = useSelector(isFetchingHearingsSelector);
  const fieldTemplateBeingUpdated = useSelector(
    fieldTemplateBeingUpdatedSelector,
  );

  const onChangeDropDown = (_, value) => {
    setSelectedHearingTypeKey(value.key);
    setSelectedFieldTemplateKey(noSelectionKey);
  };

  const onSetTitleFilter = (value) => {
    setTitleFilter(value);

    let newState = Object.assign({}, filterAndSortingSelection);
    newState[filterAndSortingKeys.title] = value || noSelectionKey;
    setFilterAndSortingSelection(newState);
  };

  const onSearchBarClick = () => {
    setShowSearchBar(!showSearchBar);
    if (showSearchBar) {
      onSetTitleFilter(null);
    }
  };

  const onPanelOpen = () => {
    dispatch(setIsPanelOpen(true));
  };

  const OnDeleteButtonPress = () => {
    dispatch(
      deleteFieldTemplate({
        hearingTypeId: selectedHearingTypeKey,
        fieldTemplateId: selectedFieldTemplateKey,
      }),
    );
  };
  const onEditButtonPress = () => {
    dispatch(
      setFieldTemplateModel({ fieldTemplateId: selectedFieldTemplateKey }),
    );
    onPanelOpen();
  };

  const topCommandBarItems = getFieldTemplateCommandBarItems(
    translator,
    OnDeleteButtonPress,
    onEditButtonPress,
    selectedFieldTemplateKey,
    fieldTemplateBeingUpdated,
  );

  return (
    <div className="admin-page">
      <div className="admin-page-commandBar">
        <CommandBar items={topCommandBarItems} styles={commandBarStyles} />
      </div>
      <div className="admin-page-container">
        <HeaderWithCommandBar
          header={translator('pages.adminFieldTemplates.header')}
          titleFilterText={translator('pages.adminFieldTemplates.filterText')}
          showTitleFilter={showSearchBar}
          setShowTitleFilter={onSearchBarClick}
          titleFilter={titleFilter}
          setTitleFilter={onSetTitleFilter}
          disableGrid={true}
        />
        {isFetchingHearings || isFetchingHearingTypes ? (
          <Spinner size={SpinnerSize.large} />
        ) : (
          <div>
            <Dropdown
              label={translator('hearingProperties.hearingType')}
              styles={dropdownStyles}
              options={optionsMapperWithNoSelection(translator)(hearingTypes)}
              onChange={onChangeDropDown}
              selectedKey={selectedHearingTypeKey}
            />
            <div style={{ paddingTop: '30px' }}>
              {isFetchingHearingTypes ? (
                <Spinner size={SpinnerSize.large} />
              ) : selectedHearingTypeKey === noSelectionKey ? null : (
                <FieldTemplateLists
                  hearingTypeId={selectedHearingTypeKey}
                  filterAndSortingSelection={filterAndSortingSelection}
                  setFilterAndSortingSelection={setFilterAndSortingSelection}
                  selectedFieldTemplateKey={selectedFieldTemplateKey}
                  setSelectedFieldTemplateKey={setSelectedFieldTemplateKey}
                  onPanelOpen={onPanelOpen}
                />
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export { FieldTemplateAdministrationPage };

const commandBarStyles = {
  root: {
    backgroundColor: '#FAFAFA',
    paddingRight: '0px',
    Width: 'auto',
  },
};

const dropdownStyles = {
  root: {
    width: '30%',
    minWidth: '300px',
    maxWidth: 425,
    height: 32,
  },
  dropdownOptionText: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
};
